<template>
	<div class="modal-holder" :class="{'is-closing': isClosing}" v-if="isVisible">
		<div class="modal-backdrop" @click="close()"></div>
		<div class="modal">
			<div class="modal-header">
				<!--<dl v-if="place && $route && $route.name !== 'coverage'">-->
				<dl v-if="place">
					<dt><svg><use xlink:href="#map-pin"></use></svg></dt>
					<dd><formatted-address :place="place"></formatted-address></dd>
				</dl>
				<div class="close" @click="close()"><svg><use xlink:href="#cross"></use></svg></div>
			</div>
			<div class="modal-close" @click="close()"><svg><use xlink:href="#cross"></use></svg></div>
			<!--<slot></slot>-->
			<router-view></router-view>
			<div class="modal-loader" v-if="isLoading">
				<loader></loader>
			</div>
		</div><!-- end.modal -->
	</div>
</template>
<script>
	import Loader from '../components/Loader'
	import FormattedAddress from "../components/FormattedAddress";

	export default {
		components: {
			FormattedAddress,
			Loader
		},
		computed: {
			isVisible() {
				return this.$store.getters['general/modalIsVisible'];
			},
			place() {
				return this.$store.getters['coverage/place']
			}
		},
		data() {
			return {
				isClosing: false,
				isLoading: false,
			}
		},
		methods: {
			close() {
				this.isClosing = true;
				setTimeout(() => {
					this.$store.commit('general/updateModalVisibility', false);
					this.isClosing = false;
				}, 300);
			}
		},
		mounted() {
			this.$on('toggle-loading', (state) => {
				this.isLoading = state;
			});

			this.$on('close', () => {
				this.close();
			});
		}
	}
</script>
